module.exports = __webpack_public_path__ + "img/ES.64cd04d7.svg";